import React from 'react';
import './TermsPage.css';

const TermsPage = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <div className="terms-header">
          <h1>Terms & Conditions — TRYON</h1>
          <p className="welcome-text">Welcome to TRYON!</p>
          <p className="intro-text">
            These Terms & Conditions govern all purchases made through our website. By placing an order, you agree to the following policies:
          </p>
        </div>

        <div className="terms-section">
          <div className="section-number">1</div>
          <div className="section-content">
            <h2>General Information</h2>
            <p>
              TRYON specializes in delivering high-quality printed T-shirts. All products displayed on our
              website are subject to availability. We reserve the right to modify pricing, policies, or product
              details without prior notice.
            </p>
          </div>
        </div>

        <div className="terms-section">
          <div className="section-number">2</div>
          <div className="section-content">
            <h2>Order Processing</h2>
            <ul>
              <li>Orders are processed after successful payment confirmation or Cash on Delivery (COD) approval.</li>
              <li>Once an order is placed, it cannot be modified or cancelled.</li>
            </ul>
          </div>
        </div>

        <div className="terms-section">
          <div className="section-number">3</div>
          <div className="section-content">
            <h2>Shipping & Delivery</h2>
            <ul>
              <li>Standard delivery time for orders is <strong>7–15 business days</strong> from the date of dispatch.</li>
              <li>Shipping time may vary based on location, logistics availability, and external factors beyond our control (e.g., weather, holidays).</li>
              <li>Customers will receive tracking details once the order is shipped.</li>
            </ul>
          </div>
        </div>

        <div className="terms-section">
          <div className="section-number">4</div>
          <div className="section-content">
            <h2>Payment Options</h2>
            <p>We offer the following payment modes:</p>
            <div className="payment-cards">
              <div className="payment-card">
                <div className="card-icon">💳</div>
                <h3>Prepaid</h3>
                <p>Online Payment</p>
              </div>
              <div className="payment-card">
                <div className="card-icon">💵</div>
                <h3>COD</h3>
                <p>Cash on Delivery</p>
                <p className="note-text">(additional fee may be applied)</p>
              </div>
            </div>
            <p className="info-text">
              Shipping charges (and additional COD fees, if any) will be displayed at checkout before order confirmation.
            </p>
          </div>
        </div>

        <div className="terms-section">
          <div className="section-number">5</div>
          <div className="section-content">
            <h2>Return & Exchange Policy</h2>
            <div className="policy-highlight">
              <p>Since each product is custom-printed specifically for your order, returns or exchanges are allowed only under the following conditions:</p>
              <ol className="conditions-list">
                <li>Wrong product received (wrong size/design/color)</li>
                <li>Product damaged or defective on arrival</li>
              </ol>
            </div>
            
            <div className="request-box">
              <h3>To request a return/exchange:</h3>
              <ul>
                <li>Contact us within 48 hours of delivery with unboxing photos/video as proof.</li>
                <li>Items must be unused, unwashed, and in original packaging.</li>
              </ul>
            </div>

            <div className="warning-notice">
              <div className="notice-icon">⚠️</div>
              <p>Returns due to wrong size selection or change of mind are not accepted.</p>
            </div>
          </div>
        </div>

        <div className="terms-section">
          <div className="section-number">6</div>
          <div className="section-content">
            <h2>Refunds</h2>
            <ul>
              <li>Approved returns will be eligible for either replacement or store credit.</li>
              <li>Prepaid refunds will be processed to the original payment method after inspection.</li>
              <li>COD refunds will be issued as store credit only.</li>
              <li>Refund processing may take 7–10 business days.</li>
            </ul>
          </div>
        </div>

        <div className="terms-section">
          <div className="section-number">7</div>
          <div className="section-content">
            <h2>Intellectual Property</h2>
            <p>
              All designs, logos, product images, and brand assets displayed by TRYON are property of the
              brand and cannot be used, copied, or reproduced without permission.
            </p>
          </div>
        </div>

        <div className="terms-section">
          <div className="section-number">8</div>
          <div className="section-content">
            <h2>Contact Information</h2>
            <p>For order or support queries, please reach out to us at:</p>
            <div className="contact-info">
              <div className="contact-item">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
                <div>
                  <strong>Support Email</strong>
                  <a href="mailto:tyon.wear02@gmail.com">tyon.wear02@gmail.com</a>
                </div>
              </div>
              <div className="contact-item">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
                </svg>
                <div>
                  <strong>Customer Care</strong>
                  <a href="tel:+919265490049">+91 9265490049</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="terms-footer">
          <div className="footer-icon">📋</div>
          <p>
            By placing an order with TRYON, you confirm that you have read, understood, and agreed to all
            the above Terms & Conditions
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
